import { render, staticRenderFns } from "./BalanceHistoryTableUser.vue?vue&type=template&id=0f8a328c&scoped=true"
import script from "./BalanceHistoryTableUser.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a328c",
  null
  
)

export default component.exports